var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-player d-flex justify-content-center",attrs:{"id":"conteudoVideo"}},[_c('video',{ref:"videoPlayer",staticClass:"video-js vjs-default-skin vjs-big-play-centered",attrs:{"id":"videoPlayer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }